import { useState } from "react";
import { getParamFromURL, setParamInURL } from "./tools";

export const useParameter = <T extends string | number | boolean>(
  paramName: string,
  defaultValue: T | null = null,
  dataType: "string" | "number" | "boolean" = "string"
): [T, (value: T) => void] => {
  const [parameter, setParameter] = useState<T>(() => {
    const value = getParamFromURL(paramName, defaultValue);
    console.log(`useParameter ${value}`);
    // Преобразование значения в соответствующий тип данных
    switch (dataType) {
      case "number":
        return parseFloat(value as string) as T;
      case "boolean":
        console.log(`useParameter ${typeof value}`);
        if (typeof value === "string") return (value === "true") as T;
        return value as T;
      default:
        return value as T;
    }
  });

  // Обновляем параметр в URL и состоянии при вызове setParameter
  const updateParameter = (value: T): void => {
    console.log(`setParam ${value}`);
    setParameter(value);
    setParamInURL(paramName, value);
  };

  return [parameter, updateParameter];
};
